import { BreadcrumbModel } from '@/models/CategoryDetail';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
} from '@/components/ui/breadcrumb';
import { ChevronRight } from '@/icons/ChevronRight';
import Link from 'next/link';
import { getBreadcrumbJsonLd } from '@/lib/utils';

export function BreadcrumbView({
  breadcrumb,
  className,
  includeJsonLd = true,
}: {
  breadcrumb: BreadcrumbModel[];
  className?: string;
  includeJsonLd?: boolean;
}) {
  return (
    <section>
      {includeJsonLd && breadcrumb.length > 0 && (
        <script
          id="json-ld-breadcrumb"
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(getBreadcrumbJsonLd(breadcrumb)),
          }}
        />
      )}
      <Breadcrumb>
        <BreadcrumbList className={className}>
          {breadcrumb.map((item, index) => {
            return (
              <div key={index} className="contents">
                <BreadcrumbItem key={index} className="flex flex-row items-center">
                  <BreadcrumbLink asChild className="text-[10px] font-semibold">
                    {index === breadcrumb.length - 1 ? (
                      <span className="text-[#5C5C57] hover:text-[#5C5C57]">{item.title}</span>
                    ) : (
                      <Link
                        href={item.url}
                        aria-label={item.title}
                        className="text-[#2B3280] hover:text-[#2B3280]"
                      >
                        {item.title}
                      </Link>
                    )}
                  </BreadcrumbLink>
                </BreadcrumbItem>
                {index !== breadcrumb.length - 1 && (
                  <ChevronRight className="text-[11px] text-[#64748B] shrink-0 mx-1" />
                )}
              </div>
            );
          })}
        </BreadcrumbList>
      </Breadcrumb>
    </section>
  );
}
